import { Outlet } from "react-router-dom";
import { useProfile } from "@/providers/ProfileProvider";
import { TenantPausedNotice } from "@/components/TenantOffboardedScreen";

/**
 * Pathless layout route around the AI surfaces (/agent/*).
 *
 * A tenant whose trial is paused (tenant.offboarded with reason "testphase") keeps the
 * whole app except the service assistant and the chat, so those routes render the notice
 * instead of the page. This is presentation only — Jupiter's TenantOffboardingGate
 * refuses the same fields server-side, so a stale build or a typed-in URL gets an error
 * rather than an answer.
 */
export default function PausedRouteGuard() {
  const { tenantPaused, tenantPausedMessage, tenantPausedContact } =
    useProfile();
  if (!tenantPaused) return <Outlet />;
  return (
    <TenantPausedNotice
      message={tenantPausedMessage}
      contactEmail={tenantPausedContact}
    />
  );
}
